//#region Libraries
import { useState } from "react";
//#endregion
//#region Styles
import { Content } from "../../../../styles";
//#endregion
//#region Components
import CustomTableList from "components/CustomTableList/CustomTableList";
//#endregion
//#region Icons
import CalendarIcon from "icons/CalendarIcon";
import MessageIcon from "icons/MessageIcon";
import TrashIcon from "icons/TrashIcon";
import TableListItem from "../TableListItem/TableListItem";
import { GET_DIALOG_DELETE_PROPS, SAVE_TYPE } from "../../../Dialogs/constants";
//#endregion

const HEADERS_TABLE_LIST = [
    {
        title: "Fecha",
        icon: <CalendarIcon/>
    },
        {
        title: "Motivo",
        icon: <MessageIcon/>
    },
    {
        title: "Eliminar",
        icon: <TrashIcon color="var(--dark-2)"/>
    }
];

const NonBusinessDaysRecords = ({
    nonBusinessDays,
    openDialogConfirmDelete,
    deleteNonBusinessDay
}) => {
    const triggerDelete = ({
        id,
        date
    }) => {
        openDialogConfirmDelete({
            props: GET_DIALOG_DELETE_PROPS[SAVE_TYPE.NON_BUSINESS_DAY](date),
            deleteAction: () => deleteNonBusinessDay(id)
        });
    }
    return (
        <Content className="custom-scrollbar primary">
            <CustomTableList
                headers={HEADERS_TABLE_LIST}
                variant="secondary"
                scrollColor="secondary"
                minWidth="400px">
                {nonBusinessDays.map(item => (
                    <TableListItem
                        key={item.id} 
                        {...item}
                        deleteItem={triggerDelete}/>
                ))}
            </CustomTableList>
        </Content>
    );
}

export default NonBusinessDaysRecords;